import { render, staticRenderFns } from "./InserirProducao.vue?vue&type=template&id=c6a923ec&scoped=true"
import script from "./InserirProducao.vue?vue&type=script&lang=js"
export * from "./InserirProducao.vue?vue&type=script&lang=js"
import style0 from "./InserirProducao.vue?vue&type=style&index=0&id=c6a923ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a923ec",
  null
  
)

export default component.exports